"use client";

import WorldMap, { type WorldMapDot } from "@/components/ui/world-map";
import { useStoryFactsActive } from "@/components/sections/story/StoryFacts";
import { useContent } from "@/components/site/ContentProvider";
import type { SiteContent } from "@/content/schema";

function marketPoint(site: SiteContent, id: string) {
  const market = site.markets.find((m) => m.id === id);
  if (!market) {
    throw new Error(`Unknown market id: ${id}`);
  }
  return {
    lat: market.lat,
    lng: market.lng,
    label: market.name,
  };
}

/** Routes radiating from Cairo (EG) plus a few regional links. */
function buildMarketDots(site: SiteContent): WorldMapDot[] {
  const eg = marketPoint(site, "eg");
  const kw = marketPoint(site, "kw");
  const ae = marketPoint(site, "ae");
  const sa = marketPoint(site, "sa");
  const us = marketPoint(site, "us");
  const de = marketPoint(site, "de");
  const dk = marketPoint(site, "dk");

  return [
    { start: eg, end: kw },
    { start: eg, end: ae },
    { start: eg, end: sa },
    { start: eg, end: us },
    { start: eg, end: de },
    { start: eg, end: dk },
    { start: ae, end: sa },
    { start: de, end: dk },
  ];
}

/**
 * Aceternity dotted map — second Our Story plane.
 * Pin/route motion waits for story enter (same signal as side facts).
 */
export function StoryWorldMap() {
  const site = useContent();
  /* ~1.9s after story-in so headline settles before routes draw. */
  const active = useStoryFactsActive(1900);

  return (
    <div className="about_map_wrap _ele" aria-label={site.aria.marketsMap}>
      <WorldMap
        className="about_map_canvas"
        dots={buildMarketDots(site)}
        lineColor="#ffffff"
        active={active}
        animationDelay={0.15}
      />
      <ul className="about_map_labels f f-w j-c a-c">
        {site.markets.map((market) => (
          <li key={market.id} className="small label light_60">
            {market.name}
          </li>
        ))}
      </ul>
    </div>
  );
}
